import React from 'react';
import UseCaseTemplate from '@/components/use-cases/UseCaseTemplate';

const summary = [
  'Predictable review response without extra headcount',
  'Better local visibility and discovery',
  'Clear reporting for owner decision‑making'
];

const challenges = [
  {
    title: 'Limited time and resources',
    description: 'Owners are busy running the business, leaving reviews and GBP unmanaged.'
  },
  {
    title: 'Unpredictable reputation',
    description: 'One bad review can impact calls, bookings, and walk‑ins overnight.'
  },
  {
    title: 'Low local visibility',
    description: 'Search results are competitive, and small mistakes reduce rankings.'
  }
];

const timeline = [
  {
    title: 'Diagnose',
    description: 'Audit reviews, GBP health, and local visibility gaps.'
  },
  {
    title: 'Stabilise',
    description: 'Implement response workflows, templates, and escalation rules.'
  },
  {
    title: 'Grow',
    description: 'Optimise GBP and local SEO to drive more calls and visits.'
  },
  {
    title: 'Report',
    description: 'Monthly visibility and reputation reporting with actions.'
  }
];

const pillars = [
  {
    title: 'Review Response Engine',
    description: 'On‑brand response playbooks, triage, and fast replies to protect trust.'
  },
  {
    title: 'Local Visibility Lift',
    description: 'GBP optimisation, local SEO hygiene, and content updates that improve rank.'
  },
  {
    title: 'Monthly Trust Reporting',
    description: 'Simple performance dashboards for owners—what changed and why.'
  }
];

const deliverables = [
  'GBP audit and optimisation',
  'Review response workflows and escalation rules',
  'Monthly visibility and sentiment report',
  'Local SEO fixes and content recommendations'
];

const kpis = [
  '20–40% increase in profile actions within 90 days',
  '2–4x faster review response time',
  'Improved average rating and review velocity'
];

const example = {
  title: 'Example: 2‑location services business',
  result:
    'After cleaning GBP data, improving review response, and posting weekly updates, calls increased by 31% and negative review impact dropped within 8 weeks.'
};

export default function SmallBusiness() {
  return (
    <UseCaseTemplate
      seoTitle="Use Case: Small Business"
      seoDescription="Local visibility and review management for small businesses."
      path="/use-cases/small-business"
      title="Small Business"
      subtitle="We help small businesses convert reviews into trust and local visibility into revenue."
      summary={summary}
      challenges={challenges}
      pillars={pillars}
      timeline={timeline}
      deliverables={deliverables}
      kpis={kpis}
      example={example}
    />
  );
}
